(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('promiseCacheService', promiseCacheService);

  function promiseCacheService($q, $http, cacheService) {
    'ngInject';

    const cachePrefix = 'promiseCache-';

    const service = {
      getCallWithCachedPromise: getCallWithCachedPromise,
      clean: clean,
      clearAll: clearAll
    };
    
    return service;

    function clean(key){
      cacheService.set(cachePrefix + key, null);
    }

    function clearAll() {
      cacheService.removeByPrefix(cachePrefix);
    }

    function getCallWithCachedPromise(key, url, exp, success, failure) {

      let promise = cacheService.get(cachePrefix + key);
      if (promise) {
        return promise;
      }

      const deferred = $q.defer();
      $http.get(url).then(function (response) {
        if (success) {
          success(response);
        }
        if (exp === 0) {
          cacheService.remove(cachePrefix + key);
        }
        deferred.resolve(response);

      }).catch(function (response) {
        if (failure) {
          failure(response);
        }
        cacheService.set(cachePrefix + key, null);
        deferred.reject(response);
      });

      promise = deferred.promise;
      if (exp === 0) {
        cacheService.set(cachePrefix + key, promise);
      } else {
        cacheService.set(cachePrefix + key, promise, {
          expireAfterSeconds: exp,
          persistence: false
        });
      }

      return promise;
    }
  }
})();
